module.exports = __webpack_public_path__ + "static/media/5.c74dfa76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/5.jpg
// module id = 538
// module chunks = 0